"use client";
import React, { useState, useEffect, useRef } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {getAssetUrl} from "@/lib/helpers/getAssetUrl";

const TestimonialCarousel = ({data, isVariant = false}) => {
    console.log("Data : ", data)
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        slides: {
            perView: 3,
            spacing: 20,
        },
        breakpoints: {
            "(max-width: 1024px)": {
                slides: {
                    perView: 2,
                    spacing: 15,
                },
            },
            "(max-width: 640px)": {
                slides: {
                    perView: 1,
                    spacing: 10,
                },
            },
        },
        created() {
            setLoaded(true);
        },
    });


    if(!data) return <></>;
    return (
        <div className="py-5 md:py-16 bg-white">
            <div className="container mx-auto px-10">
                <div className="text-center mb-6 md:mb-12">
                    <h2 className={`text-3xl md:text-[46px] font-bold mb-4 ${isVariant ? 'text-primary' : 'text-black'}`}>{data.title}</h2>
                    <p className="text-gray-600 max-w-xl mx-auto">{data.complement}</p>
                </div>

                <div className="relative">
                    <div ref={sliderRef} className="keen-slider min-h-[280px]">
                        {data.item.map((testimonial, index) => (
                            <div key={index} className="keen-slider__slide">
                                <div className="bg-white p-6 h-full flex flex-col justify-between items-center  rounded-lg shadow-sm">
                                    <p className=" italic text-center mb-6 flex-grow font-semibold">&quot;{testimonial.quote}&quot;</p>
                                    <div>
                                        <div className="flex justify-center pb-5">
                                            <img src={getAssetUrl(testimonial.image)} className={"w-16 h-16 aspect-square object-cover rounded-full"}/>
                                        </div>
                                        <h4 className="font-semibold text-center">{testimonial.name}</h4>
                                        <p className="text-gray-500 text-sm text-center">{testimonial.position}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {loaded && instanceRef.current && (
                        <>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    instanceRef.current?.prev();
                                }}
                                className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white w-10 h-10 rounded-full shadow-md flex items-center justify-center border border-gray-200"
                                disabled={currentSlide === 0}
                            >
                                <ChevronLeft className={currentSlide === 0 ? "text-gray-300" : "text-gray-700"} size={24} />
                            </button>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    instanceRef.current?.next();
                                }}
                                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white w-10 h-10 rounded-full shadow-md flex items-center justify-center border border-gray-200"
                                disabled={
                                    currentSlide ===
                                    instanceRef.current.track.details.slides.length - instanceRef.current.options.slides.perView
                                }
                            >
                                <ChevronRight
                                    className={
                                        currentSlide ===
                                        instanceRef.current.track.details.slides.length - instanceRef.current.options.slides.perView
                                            ? "text-gray-300"
                                            : "text-gray-700"
                                    }
                                    size={24}
                                />
                            </button>
                        </>
                    )}
                </div>

                {loaded && instanceRef.current && (
                    <div className="flex justify-center mt-8">
                        {[...Array(Math.max(instanceRef.current.track.details.slides.length - instanceRef.current.options.slides.perView + 1, 1)).keys()].map((idx) => (
                            <button
                                key={idx}
                                onClick={() => {
                                    instanceRef.current?.moveToIdx(idx);
                                }}
                                className={`w-2 h-2 mx-1 rounded-full ${
                                    currentSlide === idx ? "bg-gray-800" : "bg-gray-300"
                                }`}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TestimonialCarousel;